import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';

import themeToken from '@lib/theme/tokens/index';
import DeleteIcon from '@/components/Icons/DeleteIcon';

import { StyledActionIconContainer } from './StyledActionIconContainer';
import { useTrackEvent } from '@/hooks/useTrackEvents';

const { Text } = Typography;

type Props = {
  disabled: boolean;
  isWhiteBgColor?: boolean;
  hasLabel?: boolean;
  isVertical?: boolean;
  setSelectedFile?: () => void;
  setIsDeleteModalOpen: () => void;
  closeDropdown?: () => void;
};

const FileDelete = ({
  setSelectedFile,
  hasLabel = true,
  isWhiteBgColor = false,
  isVertical = true,
  disabled,
  setIsDeleteModalOpen,
  closeDropdown,
}: Props) => {
  const { sendMixpanelEvent } = useTrackEvent({ page: 'dataroom' });
  const { t } = useTranslation('dataroom');

  return (
    <Flex
      onClick={(e) => {
        if (disabled) return;
        sendMixpanelEvent('delete-file-btn-clicked');
        e.stopPropagation();
        setSelectedFile?.();
        setIsDeleteModalOpen();
        closeDropdown?.();
      }}
      vertical={isVertical}
      align="center"
      gap={isVertical ? 2 : 8}
      style={{ cursor: !disabled ? 'pointer' : 'not-allowed' }}
    >
      <StyledActionIconContainer isWhiteBgColor={isWhiteBgColor} isVertical={isVertical}>
        <DeleteIcon />
      </StyledActionIconContainer>
      {hasLabel && (
        <Text
          style={{
            color: themeToken['branding-primary-3'],
            fontSize: themeToken.fontSizeSM,
            fontWeight: 400,
          }}
        >
          {t('delete')}
        </Text>
      )}
    </Flex>
  );
};

export default FileDelete;
